import { ItemLocationHistory } from '@api/Trinium/Endpoints/Consignment/types';

import styles from './DataGrid.ItemLocationHistory.module.css';

interface ItemLocationHistoryMobileItemProps {
	itemHistory: ItemLocationHistory;
}

export default function ItemLocationHistoryMobileItem({ itemHistory }: ItemLocationHistoryMobileItemProps) {
	return (
		<div className={styles['mobile-li']}>
			<div className={styles['action']}>
				<span>{itemHistory.desc}</span>
			</div>
			<div className={styles['flex-row']}>
				<div>
					<span className={styles['heading']}>Loc</span>
					<span className={styles['value']}>{itemHistory.typeId}</span>
				</div>
				<div>
					<span className={styles['heading']}>X</span>
					<span className={styles['value']}>{itemHistory.xLoc}</span>
				</div>
				<div>
					<span className={styles['heading']}>Y</span>
					<span className={styles['value']}>{itemHistory.yLoc}</span>
				</div>
				<div>
					<span className={styles['heading']}>Z</span>
					<span className={styles['value']}>{itemHistory.zLoc}</span>
				</div>
				<div>
					<span className={styles['heading']}>Action</span>
					<span className={styles['value']}>{itemHistory.action}</span>
				</div>
			</div>
			{itemHistory.actionDesc && (
				<div>
					<span className={styles['heading']}>Details</span>
					<span>{itemHistory.actionDesc}</span>
				</div>
			)}
			<div className={styles['authored']}>
				<span>{itemHistory.usrCode}</span>
				<span>{itemHistory.timestamp?.date}</span>
			</div>
		</div>
	);
}
